var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3992 19.0998C12.8681 19.5686 13.504 19.832 14.167 19.832C14.83 19.832 15.4659 19.5686 15.9348 19.0998C16.4036 18.631 16.667 17.9951 16.667 17.332C16.667 16.669 16.4036 16.0331 15.9348 15.5643C15.4659 15.0954 14.83 14.832 14.167 14.832C13.504 14.832 12.8681 15.0954 12.3992 15.5643C11.9304 16.0331 11.667 16.669 11.667 17.332C11.667 17.9951 11.9304 18.631 12.3992 19.0998Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6014 19.0998C28.0703 18.631 28.3337 17.9951 28.3337 17.332C28.3337 16.669 28.0703 16.0331 27.6014 15.5643C27.1326 15.0954 26.4967 14.832 25.8337 14.832C25.1706 14.832 24.5347 15.0954 24.0659 15.5643C23.5971 16.0331 23.3337 16.669 23.3337 17.332C23.3337 17.9951 23.5971 18.631 24.0659 19.0998C24.5347 19.5686 25.1706 19.832 25.8337 19.832C26.4967 19.832 27.1326 19.5686 27.6014 19.0998Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 28.1654V24.832H13.3337V28.1654H26.667Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNormal);
export default __webpack_public_path__ + "static/media/IconNormal.64fd9b2153802b1820a60217cf34dc79.svg";
export { ForwardRef as ReactComponent };